import ApiService from "./ApiService"

export async function apiGetMembers(params) {
  return ApiService.fetchData({
    url: '/users',
    method: 'get',
    params
  })
}

export async function apiUpdateLeader(data) {
  return ApiService.fetchData({
    url: '/users/updateLeader',
    method: 'post',
    data
  })
}


export async function apiUpdateAgent(data) {
  return ApiService.fetchData({
    url: '/users/updateAgent',
    method: 'post',
    data
  })
}

export async function apiUpdateLocation(data) {
  return ApiService.fetchData({
    url: '/users/updateLocation',
    method: 'post',
    data
  })
}

export async function apiUpdateRole(data) {
  return ApiService.fetchData({
    url: '/users/updateRole',
    method: 'post',
    data
  })
}

export async function apiGetManagers() {
  return ApiService.fetchData({
    url: '/users/get_managers',
    method: 'get',
  })
}

export async function apiGetRecentMembers() {
  return ApiService.fetchData({
    url: '/users/get_recent_members',
    method: 'get',
  })
}

export async function apiUpdateProfile(data) {
  return ApiService.fetchData({
    url: '/users/' + data.get('id') + '?_method=PUT',
    method: 'post',
    data
  })
}

export async function apiCreateUser(data) {
  return ApiService.fetchData({
    url: '/users/create',
    method: 'post',
    data
  })
}

export async function apiUpdateWallets(data) {
  return ApiService.fetchData({
    url: '/users/wallets/' + data.get('id') + '?_method=PUT',
    method: 'post',
    data
  })
}